import { Col, Form, Input, Layout, List, message, Modal, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import CustomerSelect from '../../lib/CustomerSelect';
import { API } from '../../api';
import queryString from 'query-string';
import { notifyError, notifySuccess } from '../../store/utils';

interface Props {
  visible?: boolean;
  onClose: () => void;
}
const CreateOrderdraftPackage = ({ visible, onClose }: Props) => {
  const [state, changeState] = useState<any>({});
  const [form] = Form.useForm();
  const [filter, changeFilter] = useState<any>({
    hasPackage: 'NO',
    customer: undefined,
  });
  useEffect(() => {
    if (visible) {
      fetchContent(`?${queryString.stringify(filter)}`);
    }
  }, [visible, filter]);
  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        if (state.result?.data && state.result?.data.length > 0) {
          const result = await API.post({ apiVersion: 'api' })(`/order_draft/package/create`, data);
          notifySuccess('Богц амжилттай үүслээ');

          onClose();
        } else {
          notifyError('Хоосон богц үүсгэж болохгүй');
        }
      } catch (e) {}
      // if(filter.customer===undefined)
    },
    [filter, state]
  );
  const fetchContent = async (filter: any) => {
    try {
      changeState({ loading: true, result: {} });
      const response = await API.get({ apiVersion: 'api' })(`/order_draft/parcel/list${filter}`);
      changeState({ loading: false, result: response.result });
    } catch (e) {
      changeState({ loading: false, error: true, result: {}, errors: e });
    }
  };
  return (
    <Modal
      open={visible}
      loading={state.loading}
      onCancel={onClose}
      title={`Уридчилсан захиалгын богц-${state.result?.total ?? ''}`}
      onOk={() => form.submit()}
    >
      <Layout.Content>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={15}>
            <Col span={12}>
              <Form.Item name={'packageNumber'} label="Богцын дугаар" rules={[{ required: true }]}>
                <Input placeholder="Богцын дугаар" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name={'customer'} label="Харилцагч" rules={[{ required: true }]}>
                <CustomerSelect
                  value={filter.customer}
                  onChange={(e) => changeFilter({ ...filter, customer: e })}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <List
                itemLayout="horizontal"
                dataSource={state.result?.data}
                renderItem={(item: any, index) => (
                  <List.Item>
                    <List.Item.Meta
                      title={<a href="https://ant.design">{item.trackingNumber}</a>}
                      description="Ant Design, a design language for background applications, is refined by Ant UED Team"
                    />
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Form>
      </Layout.Content>
    </Modal>
  );
};
export default CreateOrderdraftPackage;
